// Centralized content data for Albany Staffing

export const COMPANY = {
  name: "Albany Staffing",
  legalName: "Albany Systems LLC",
  dbaStatement: "Albany Staffing is a DBA of Albany Systems LLC",
  tagline: "Connecting The Brightest Minds",
  positioning: "IT & Non-IT Recruitment · Direct Hire Staffing",
  address: "650 Warrenville Rd, Suite 100, Lisle, IL 60532",
  phone: "+1 (630) 555-0120",
  email: "HR@albanyllc.com",
  foundedYear: 2015,
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Industries", href: "/industries" },
  { label: "Careers", href: "/careers" },
  { label: "Contact", href: "/contact" },
];

export const TOP_CTAS = [
  { label: "Refer a Friend", href: "/careers", icon: "users" },
  { label: "Search Jobs", href: "/careers", icon: "search" },
  { label: "Submit Resume", href: "/careers", icon: "upload" },
];

export const STATS = [
  { value: "120+", label: "Placements Delivered" },
  { value: "94%", label: "Client Retention" },
  { value: "72h", label: "Avg. Shortlist Time" },
  { value: "10+", label: "Years of Expertise" },
];

export const GROWTH_STATS = [
  { value: "50K+", label: "Candidates Vetted" },
  { value: "30+", label: "Placements Per Quarter" },
  { value: "25+", label: "Active Client Partners" },
  { value: "6", label: "Industry Verticals" },
];

export const SERVICES = [
  { id: "direct-hire", number: "01", title: "Direct Hire Staffing", description: "Permanent placement for roles that define your business. We source, vet, and deliver candidates who stay." },
  { id: "staff-augmentation", number: "02", title: "Staff Augmentation", description: "On-demand engineers and specialists who integrate with your team from day one — billed hourly or by project." },
  { id: "executive-search", number: "03", title: "Executive Search", description: "Discreet, high-touch search for Director, VP, and C-suite leaders across IT, engineering, and operations." },
  { id: "contract-staffing", number: "04", title: "Contract Staffing", description: "Short and long-term contract talent for project surges, seasonal demand, and specialized builds." },
  { id: "technical-recruitment", number: "05", title: "Technical Recruitment", description: "Deep-domain recruiters who know the difference between Spring Boot and Spring MVC, PLC and DCS." },
  { id: "it-consulting", number: "06", title: "IT Consulting", description: "Advisory engagements for hiring strategy, talent benchmarking, compensation studies, and workforce planning." },
];

export const INDUSTRIES = [
  { id: "it", name: "Information Technology", blurb: "Full-stack engineers, cloud architects, data scientists, cybersecurity analysts, SREs, product leaders." },
  { id: "healthcare", name: "Healthcare", blurb: "Clinical informaticists, HL7/FHIR engineers, EHR specialists, medical device engineers, RCM leaders." },
  { id: "defense", name: "Defense", blurb: "Cleared engineers, systems integrators, mission software developers, and program managers for DoD primes." },
  { id: "aerospace", name: "Aerospace", blurb: "Avionics engineers, propulsion specialists, stress analysts, manufacturing and quality leaders." },
  { id: "life-sciences", name: "Life Sciences", blurb: "Validation engineers, QA/QC, regulatory affairs, bioprocess engineers, clinical operations leaders." },
  { id: "manufacturing", name: "Manufacturing & Engineering", blurb: "Our deepest bench. Plant floor to operations leadership — end-to-end engineering talent." },
];

export const MANUFACTURING_ROLES = [
  "Manufacturing Engineer", "Process Engineer", "Industrial Engineer", "Quality Engineer",
  "Production Engineer", "Production Supervisor", "Mechanical Engineer", "Electrical Engineer",
  "Design Engineer", "R&D Engineer", "Product Development Engineer", "Plant Manager",
  "Operations Manager", "Supply Chain Manager", "Logistics Manager", "Maintenance Engineer",
  "Production Planner", "Scheduler", "Lean Manufacturing Engineer", "Six Sigma Engineer",
  "Automation Engineer", "PLC Engineer", "Robotics Engineer", "CNC Programmer",
  "Machinist", "EHS Specialist", "Tooling Engineer",
];

export const PROCESS_STEPS = [
  { step: "01", title: "Discover", description: "Deep intake on the role, team, and success criteria." },
  { step: "02", title: "Source", description: "Targeted outreach across our network and proprietary database." },
  { step: "03", title: "Vet", description: "Technical screens, reference checks, cultural calibration." },
  { step: "04", title: "Submit", description: "Curated shortlist with notes — typically within 72 hours." },
  { step: "05", title: "Close", description: "Offer coaching, onboarding, and 90-day check-ins." },
];

export const VALUES = [
  { title: "Integrity First", body: "We tell clients and candidates the truth — even when it costs us the placement." },
  { title: "Speed With Precision", body: "72-hour shortlists you actually want to interview. No resume spam." },
  { title: "Deep Specialization", body: "Recruiters who've lived the roles they hire for. Engineers placing engineers." },
  { title: "Partnership, Not Transactions", body: "We build multi-year relationships. Many of our clients have partnered with us since day one." },
];

export const JOB_LISTINGS = [
  { id: "senior-mfg-eng", title: "Senior Manufacturing Engineer", location: "Chicago, IL", type: "Full-Time · Direct Hire", industry: "Manufacturing", posted: "2 days ago" },
  { id: "cloud-architect", title: "Cloud Architect (AWS)", location: "Remote · US", type: "Full-Time · Direct Hire", industry: "Information Technology", posted: "4 days ago" },
  { id: "quality-eng", title: "Quality Engineer · Life Sciences", location: "Indianapolis, IN", type: "Contract-to-Hire", industry: "Life Sciences", posted: "1 week ago" },
  { id: "aero-stress", title: "Aerospace Stress Analyst", location: "Seattle, WA", type: "Full-Time · Direct Hire", industry: "Aerospace", posted: "3 days ago" },
  { id: "plc-eng", title: "PLC / Automation Engineer", location: "Detroit, MI", type: "Contract · 12 months", industry: "Manufacturing", posted: "5 days ago" },
  { id: "ehr-analyst", title: "EHR Integration Analyst (Epic)", location: "Dallas, TX", type: "Full-Time · Direct Hire", industry: "Healthcare", posted: "1 week ago" },
];

export const TESTIMONIALS = [
  { quote: "Albany delivered three senior hires in under a month — all still with us. Their screens are actually rigorous.", name: "Priya Raman", title: "VP Engineering, Fortune 500 Industrial" },
  { quote: "The only recruiting partner that understood the difference between a controls engineer and an automation engineer without being told.", name: "Michael Chen", title: "Plant Director, Aerospace Tier-1" },
  { quote: "We hired our entire cloud platform team through Albany. The quality-to-submission ratio was the best we've seen.", name: "Sarah Whitman", title: "CTO, Healthcare SaaS" },
];

// Memorable lines companies love — the quotes that stick
export const QUOTES = [
  { text: "Great companies aren't built on great ideas — they're built on great people.", source: "The Albany Philosophy" },
  { text: "Your next hire will either multiply your vision or divide it. We make sure it multiplies.", source: "" },
  { text: "We don't fill seats. We build the benches that win championships.", source: "" },
  { text: "Behind every breakthrough is someone who was placed at the right time.", source: "" },
];

export const SOCIAL = {
  linkedin: "https://www.linkedin.com/company/albanysystems/",
};
// Client logos (placeholder text-logos; replace with real images when supplied)
export const CLIENT_LOGOS = [
  "Halcon", "Meridian", "Northstar", "Kaizen Works", "Altura Labs",
  "Bluehaven", "Fieldstone", "Vanguard", "Apex Dynamics", "Pioneer Corp",
  "Cascade Systems", "Orion Health", "Silverpeak", "Ironclad",
];
